// Page states returned by the backend page-model endpoint
// These may change when backend is finalized — keep them here only
export const PAGE_STATES = {
  AUTH_REQUIRED: 'AUTH_REQUIRED',
  DOCUMENT_COLLECTION: 'DOCUMENT_COLLECTION',
  LINK_EXPIRED: 'LINK_EXPIRED',
  INVALID_LINK: 'INVALID_LINK',
  TEMPORARY_ERROR: 'TEMPORARY_ERROR',
  COMPLETED: 'COMPLETED',
};

// Document statuses from backend
// These may change when Salesforce field mapping is finalized
export const DOC_STATUSES = {
  REQUIRED: 'REQUIRED',
  ACCEPTED: 'ACCEPTED',
  IN_REVIEW: 'IN_REVIEW',
  APPROVED: 'APPROVED',
  NOT_APPROVED: 'NOT_APPROVED',
  NOT_REQUIRED: 'NOT_REQUIRED',
};

// Document types (used as keys in the statuses object)
export const DOC_TYPES = {
  LICENSE: 'license',
  PROTECTION: 'protection',
  INSURANCE_HISTORY: 'insurance_history', // suffixed with slot: insurance_history_1
};

// Internal screen states (frontend-only, not from backend)
export const SCREENS = {
  LOADING: 'LOADING',
  AUTH: 'AUTH',
  WELCOME: 'WELCOME',
  UPLOAD: 'UPLOAD',
  HAR_HABITUCH: 'HAR_HABITUCH',
  SUCCESS: 'SUCCESS',
  EXPIRED: 'EXPIRED',
  INVALID: 'INVALID',
  ERROR: 'ERROR',
};

// Maps backend pageState to internal screen
export const mapPageStateToScreen = (pageState, token) => {
  switch (pageState) {
  case PAGE_STATES.AUTH_REQUIRED: return SCREENS.AUTH;
  case PAGE_STATES.DOCUMENT_COLLECTION:
    if (token && sessionStorage.getItem(`doc_welcome_seen_${token}`)) {
      return SCREENS.UPLOAD;
    }
    return SCREENS.WELCOME;
  case PAGE_STATES.LINK_EXPIRED: return SCREENS.EXPIRED;
  case PAGE_STATES.INVALID_LINK: return SCREENS.INVALID;
  case PAGE_STATES.TEMPORARY_ERROR: return SCREENS.ERROR;
  case PAGE_STATES.COMPLETED: return SCREENS.SUCCESS;
  default: return SCREENS.ERROR;
  }
};
